import { render, staticRenderFns } from "./AddNewAsset.vue?vue&type=template&id=cabef88a"
import script from "./AddNewAsset.vue?vue&type=script&lang=js"
export * from "./AddNewAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports